import CheckIcon from '@mui/icons-material/Check';
import { Gapper } from '../../ui/utils';
import { colors } from '../../constants/theme';
import CTAButton from '../../ui/ctaButton';
import {
  BenefitsOverviewWrapper,
  BenefitsOverviewTitle,
  BenefitsOverviewText,
  BenefitsOverviewListTitle,
  BenefitsOverviewListItem,
  BenefitsOverviewListItemText,
} from './styles';

const BenefitsOverview = ({
  title,
  texts = [],
  list = { title: '', items: [] },
  buttonText,
  onButtonClick,
  gaps = { beforeCTAButton: 50, btwnTitleAndText: 14, btwnTexts: 30 },
  wrapperMaxWidth = 1050,
  listItemTextMaxWidth = 412,
  listGap = 20,
}) => {
  const handleButtonClick = () => {
    onButtonClick && onButtonClick();
  };

  return (
    <BenefitsOverviewWrapper maxWidth={wrapperMaxWidth}>
      <Gapper gap={gaps.beforeCTAButton}>
        <Gapper gap={gaps.btwnTitleAndText}>
          <BenefitsOverviewTitle>{title}</BenefitsOverviewTitle>
          <Gapper gap={gaps.btwnTexts}>
            {texts.map((text, index) => (
              <BenefitsOverviewText key={index}>{text}</BenefitsOverviewText>
            ))}
          </Gapper>
        </Gapper>

        {buttonText && <CTAButton text={buttonText} onClick={handleButtonClick} />}
      </Gapper>
      <Gapper gap={listGap}>
        {list.title && <BenefitsOverviewListTitle>{list.title}</BenefitsOverviewListTitle>}
        {list.items.map((item, index) => (
          <BenefitsOverviewListItem key={index}>
            <CheckIcon sx={{ fontSize: 28, color: colors.primary }} />
            <BenefitsOverviewListItemText
              dangerouslySetInnerHTML={{ __html: item }}
              maxWidth={listItemTextMaxWidth}
            />
          </BenefitsOverviewListItem>
        ))}
      </Gapper>
    </BenefitsOverviewWrapper>
  );
};

export default BenefitsOverview;
